export const DPickerDatetimeMask = wcardinal.ui.DPickerDatetimeMask;